export const ESTADOS_FORMACION = [
  { value: "inscrito", label: "Inscrito" },
  { value: "cursando", label: "Cursando" },
  { value: "egresado", label: "Egresado" },
  { value: "acreditado", label: "Acreditado" },
  { value: "anulado", label: "Anulado" },
  { value: "reprobado", label: "Reprobado" },
];

export const estadoFormacionLabel = (estado) => {
  const found = ESTADOS_FORMACION.find((e) => e.value === estado);
  return found ? found.label : estado || "Sin estado";
};
